import request from '@/utils/request'

// 中心概况
export function getCoreList() {
    return request({
        url: '/gtwg/pc/coreList',
        method: 'get'
    })
}